import { render, staticRenderFns } from "./VDrawer.vue?vue&type=template&id=7bed8bea&"
import script from "./VDrawer.vue?vue&type=script&lang=js&"
export * from "./VDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports